module.exports = __webpack_public_path__ + "static/media/rate-experience.231e5255.png";